export default {
  computed: {
    $currentUser() {
      return this.$store.state.session.user;
    },
    $role() {
      return this.$store.state.session.user.role;
    }
  }
}